import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { Component, Input, OnInit } from '@angular/core';
// import { MatDialogRef } from '@angular/material/dialog';
import { EventType, getEmptyEventType } from 'src/app/interfaces/event-type';
import { EventtypeService } from 'src/app/services/eventtype.service';
import { Storage } from '@ionic/storage-angular';
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit {
  // @Input() event: any;
  compid: any;
  // eventtype: any = {
  //   _id:"",
  //   name: "",
  //   duration: "",
  //   company: ""
  // };
  eventtype: any;
  duration = {
    hours: 0,
    minutes: 0
  }

  constructor(
    private eventtypeService: EventtypeService,
    private auth: AuthService,
    private toastS: ToastService
  ) {

    this.eventtypeService.eventtypeDataSubject.subscribe(x => {
      console.log('eventtypedata: ', x);
      this.eventtype = x;
      this.duration.hours = Math.trunc(this.eventtype.duration / 60);
      this.duration.minutes = this.eventtype.duration % 60
    })
  }

  async ngOnInit() {
    this.compid = (await this.auth.getDecodedUserToken()).company
  }

  save() {
    this.eventtype.duration = this.duration.hours * 60 + this.duration.minutes;
    console.log("EVENTTYPE: ", this.eventtype)
    if (this.eventtype.prices) {
      delete this.eventtype.prices
    }

    this.eventtypeService.saveEvent(this.eventtype).subscribe(x => {
      this.eventtypeService.eventtypeSave.next(x);
      this.toastS.addToast();
    }, err => {
      this.toastS.addToastNot();

    });
  }

  generateLink() {


    if (this.eventtype._id) {
      return `${location.origin}/clogin?id=${this.compid}&service=${this.eventtype._id}`
    }

    // http://localhost:8100/clogin?id=61385b8c4d4e07002cdbe0be&service=6255d2e1532c6b002c0d2482
    return "Link kann erst generiert werden, wenn das Event gespeichert wurde!";

  }

  copyToClipboard(text) {
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(text);
    this.toastS.showToast("success", "Link erfolgreich in die Zwischenablage kopiert!")



  }
}
